import Cookies from 'js-cookie';
import jQuery from 'jquery';

HTMLDocument.prototype.ready = function () {
	return new Promise(function (resolve, reject) {
		if (document.readyState === 'complete') {
			resolve(document);
		} else {
			document.addEventListener('DOMContentLoaded', function () {
				resolve(document);
			});
		}
	});
};

// document.ready().then(function () {
// 	const iframes = document.querySelectorAll('iframe');

// 	if (iframes.length) {
// 		iframes.forEach((iframe) => {
// 			if (iframe.src.startsWith("https://go.agio.com")) {
// 				let params = window.location.search;
// 				if (params) {
// 					iframe.src += params;
// 				}
// 			}
// 		});
// 	}
// });

// Parse the URL
function getParameterByName(name) {
	name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
	var regex = new RegExp("[\\?&amp;]" + name + "=([^&amp;#]*)"),
		results = regex.exec(location.search);
	return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}
// let source = window.location.search;
var data = getParameterByName('gclid');
const source = {
	urlParam: data,

};



if (data) {
	// localStorage.setItem('gclid', source);
	window.localStorage.setItem('gclid', JSON.stringify(source));

}

// var gclidValue = window.localStorage.getItem('gclid');
var gclidValue = JSON.parse(window.localStorage.getItem('gclid'))


if (gclidValue) {

	const iframes = document.querySelectorAll('iframe');

	if (iframes.length) {

		iframes.forEach((iframe) => {
			if (iframe.src.startsWith("https://go.agio.com")) {
				let cleanValue = Object.values(gclidValue)[0];
				let params = cleanValue;
				console.log(params)
				console.log(typeof params)

				if (params) {
					iframe.src += "?glcid=" + params;
					console.log(params)
					console.log(typeof params)
				}
			}
		});
	}
}


// if (Cookies.get("gclid") == null || Cookies.get("gclid") == "") {
// 	Cookies.get("gclid", source);
// 	document.cookie = source;
// 	console.log(source);
// 	console.log(document.cookie)
// }